import './styles.scss'
import { t } from 'i18next'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import microSignalsUtils from '../../utils/microSignals.utils'

const HistoryTerminalDataModal = ({ historyDataList, historyModalTitle, isHistoryPopupOpen, setIsHistoryPopupOpen, formatNumber, isApiError }) => {
  const { determineTextColor } = microSignalsUtils

  const handleClose = () => {
    setIsHistoryPopupOpen(false)
  }

  const renderTableBody = () => {
    if (isApiError) {
      return (
        <tr>
          <td colSpan="5" className="table-loader">
            {t('SOMETHING_WENT_WRONG')}
          </td>
        </tr>
      )
    }

    if (historyDataList?.length === 0) {
      return (
        <tr>
          <td colSpan="5" className="table-loader">
            {t('LOADING_DATA')}
          </td>
        </tr>
      )
    }

    return historyDataList.map((item, index) => (
      <tr key={index}>
        <td className="macro-signals-date">{item?.date}</td>
        <td className={determineTextColor(item?.volumeDifference)}>{formatNumber(item?.totalVolume)}</td>
        <td className={determineTextColor(item?.volumeDifference)}>
          {item?.volumeDifference > 0 ? '+' : ''}
          {formatNumber(item?.volumeDifference)}
        </td>
        <td className={determineTextColor(item?.openInterestDifference)}>{formatNumber(item?.totalOpenInterest)}</td>
        <td className={determineTextColor(item?.openInterestDifference)}>
          {item?.openInterestDifference > 0 ? '+' : ''}
          {formatNumber(item?.openInterestDifference)}
        </td>
      </tr>
    ))
  }

  const dialogModalContent = () => (
    <div className="history-macro-signals-data-table-wrapper">
      <table className="macro-signals-table">
        <thead>
          <tr>
            <th>{t('DATE')}</th>
            <th>{t('VOLUME')}</th>
            <th>{t('DIFFERENCE')}</th>
            <th>{t('OPEN_INTEREST')}</th>
            <th>{t('DIFFERENCE')}</th>
          </tr>
        </thead>

        <tbody>{renderTableBody()}</tbody>
      </table>
    </div>
  )

  return <DialogUIModal size="lg" titlePosition="center" title={`${historyModalTitle === '1' ? t('ROBUSTA') : t('ARABICA')} ${t('HISTORY_DATA')}`} showModal={isHistoryPopupOpen} handleClose={handleClose} bodyContent={dialogModalContent} />
}

export default HistoryTerminalDataModal
